import { SubmissionError } from "redux-form";
import { normalize, schema } from "normalizr";
import { notifySubmitSucceeded } from "./notifierProcesses";
import { replace } from "connected-react-router";
import { apiGet, apiPost, apiDel, apiPut } from "./helpers/api";
import { getQueryParam } from "./helpers/getQueryParam";
import { resetCrispSession } from "../utils/crisp";
import { resetPostHog } from "../utils/posthog";

export const user = new schema.Entity("users", {
  meta: {
    coursesUsers: [new schema.Entity("coursesUsers")],
    classrooms: [new schema.Entity("classrooms")],
    companies: [new schema.Entity("companies")],
  },
});

const errorOnSubmit = (err) => {
  throw new SubmissionError({
    _error:
      err.response?.body?.errors || "Ocorreu um erro durante a autenticação",
  });
};

export const setSession = (response) => {
  localStorage.setItem(
    "session",
    JSON.stringify({
      headers: {
        "access-token": response.headers["access-token"],
        client: response.headers.client,
        uid: response.headers.uid,
      },
      currentUserId: response.body.data.id,
    })
  );
};

export const signIn = (values, dispatch, props) => {
  const { redirectTo } = props;

  return apiPost("/api/v1/auth/sign_in")
    .send(values)
    .then((response) => {
      setSession(response);
      dispatch({
        type: "USER_FETCHED",
        ...normalize(response.body.data, user),
      });
      dispatch({ type: "CURRENT_USER_FETCHED", id: response.body.data.id });
      dispatch(replace(redirectTo));
      dispatch({ type: "AFTER_SIGN_IN_CLEAN_UP" });
    })
    .catch((err) => errorOnSubmit(err));
};

export const recoveryPassword = (values, dispatch, props) => {
  return apiPost("/api/v1/auth/password")
    .send({
      ...values,
      redirectUrl: `https://${window.location.host}/reset-password`,
    })
    .then(() => {
      props.reset();
    })
    .catch((err) => errorOnSubmit(err));
};

export const newPassword = (values, dispatch) => {
  return apiPut("/api/v1/auth/password")
    .send(values)
    .set("Uid", getQueryParam("uid"))
    .set("Access-Token", getQueryParam("access-token"))
    .set("Client", getQueryParam("client"))
    .then(() => {
      notifySubmitSucceeded(
        dispatch,
        "Uhuu, Sua senha foi atualizada com sucesso!"
      );
      dispatch(replace("/signin"));
    })
    .catch((err) => errorOnSubmit(err));
};

const removeLocalSession = (dispatch) => {
  resetCrispSession();
  resetPostHog();
  dispatch({ type: "CURRENT_USER_REMOVED", id: null });
  localStorage.removeItem("session");
};

export const signOut = (dispatch) => {
  apiDel("/api/v1/auth/sign_out").then(() => {
    removeLocalSession(dispatch);
    dispatch(replace("/signin"));
  });
};

// Clears the current session WITHOUT navigating away. Used when a stale
// account is logged in while landing on the account-confirmation flow: we
// must drop the old session but keep the user on /signin?confirmed=true.
// The local session is cleared even if the sign_out request fails (the old
// token may already be invalid).
export const clearSession = (dispatch) =>
  apiDel("/api/v1/auth/sign_out")
    .catch(() => {})
    .then(() => removeLocalSession(dispatch));

export const sessionValidate = (dispatch) => {
  return apiGet("/api/v1/auth/validate_token").then((response) => {
    dispatch({
      type: "USER_FETCHED",
      ...normalize(response.body.data, user),
    });
  });
};
